import React from 'react';
import './styles/Skills.css';
// import { Component } from 'react';
// import { pythonLogo, javaLogo, typescriptLogo,
//          angularLogo, reactLogo, htmlCssLogo } from '../assets';

function Skills(){
    return(
        <>
        <text className = 'skills-header'> My Skills </text>
        {/* <div className='grid-container'>
            <div>
                <img src={pythonLogo} alt='python-logo'/>
                <p> </p>
            </div>
            <div>
                <img src={javaLogo} alt='java-logo'/>
            </div>
            <div>
                <img src={typescriptLogo} alt='typescript-logo'/>
            </div>
            <div>
                <img src={htmlCssLogo} alt='html-css-logo'/>
            </div>
            <div>
                <img src={reactLogo} alt='react-logo'/>
            </div>
            <div>
                <img src={angularLogo} alt='angular-logo'/>
            </div>
        </div>*/}
        </> 
    )
}


export default Skills;